package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

/** Fetch the full product catalog (categories + products) for a location. */
@Serializable
data class GetLocationProductsRequestModel(
    val merchantLocationId: Long
) : BaseRequestModel(api = AllCommands.GET_LOCATION_PRODUCTS)

/** Create (id == null) or update (id != null) a product category. */
@Serializable
data class SaveProductCategoryRequestModel(
    val merchantLocationId: Long,
    val id: Long? = null,
    val parentCategoryId: Long? = null,
    val name: String,
    val sortOrder: Int = 0
) : BaseRequestModel(api = AllCommands.SAVE_PRODUCT_CATEGORY)

@Serializable
data class DeleteProductCategoryRequestModel(
    val categoryId: Long
) : BaseRequestModel(api = AllCommands.DELETE_PRODUCT_CATEGORY)

/** Create (id == null) or update (id != null) a product. */
@Serializable
data class SaveProductRequestModel(
    val merchantLocationId: Long,
    val id: Long? = null,
    val categoryId: Long? = null,
    val name: String,
    val description: String = "",
    val grams: Int = 0,
    val photoUrl: String = "",
    val isEnabled: Boolean = true,
    val sortOrder: Int = 0,
    /** Allergen ids (nomenclature_allergens) attached to this product. */
    val allergenIds: List<Long> = emptyList()
) : BaseRequestModel(api = AllCommands.SAVE_PRODUCT)

@Serializable
data class DeleteProductRequestModel(
    val productId: Long
) : BaseRequestModel(api = AllCommands.DELETE_PRODUCT)
